import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLazyQuery } from '@apollo/client'
import dynamic from 'next/dynamic'

import { HOME_PAGE_WIDGET } from '@graphql/home/home.query'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// const SBSpecial = dynamic(() => import('@shared/components/sbSpecial'), {
//   loading: () => (
//     <div className='mb-3'>
//       <Skeleton height={'200px'} radius={'10px'} />
//     </div>
//   )
// })

const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })
// const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })
// const LazyLoad = dynamic(() => import('@shared/components/lazyLoad'), { ssr: false })
// const FantasyTipsWidget = dynamic(() => import('@shared/components/fantasyTipsWidget'), { ssr: false })
const RankingTab = dynamic(() => import('@shared/components/rankingTab'), { ssr: false })
const TrendingNews = dynamic(() => import('@shared/components/trendingNews'), { ssr: false })
const CurrentSeries = dynamic(() => import('@shared/components/widgets/currentSeries'), { ssr: false })
const UpcomingMatches = dynamic(() => import('@shared/components/widgets/upcomingMatches'), { ssr: false })
const TopTeams = dynamic(() => import('@shared/components/widgets/topTeams'), { ssr: false })
const TrendingPlayer = dynamic(() => import('@shared/components/widgets/trendingPlayer'), { ssr: false })
const DidYouKnow = dynamic(() => import('@shared/components/widgets/didYouKnow'), { ssr: false })
// const Ads = dynamic(() => import('@shared/components/ads'), { ssr: false })
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

const Components = {
  upcomingMatches: UpcomingMatches,
  // trendingVideos: SBSpecial,
  ranking: RankingTab,
  // fantasytips: FantasyTipsWidget,
  trendingNews: TrendingNews,
  prioritySeries: CurrentSeries,
  topTeams: TopTeams,
  trendingPlayers: TrendingPlayer,
  didYouKnow: DidYouKnow
}

function AllWidget({ position, index, show, type, notShowFanTips = '' }) {
  const [getHomeWidgets, { data, error, loading }] = useLazyQuery(HOME_PAGE_WIDGET, { context: { headers: { 'Cache-Control': 'public, max-age=300, s-maxage=600, stale-while-revalidate=420' } } })
  const { add300 } = reviveAdData
  useEffect(() => {
    if (!type) {
      getHomeWidgets()
    }
  }, [])
  if (error) {
    console.error('Error fetching widgets:', error.message)
    return null
  }
  const allWidget = data?.getHomeWidgets?.filter((item) =>
    item?.eType !== 'topTeams' && item?.eType !== 'trendingPlayers'
  )
  const stringIndex = index?.toString()

  // if (loading || !allWidget || !show) {
  if (loading || !show) {
    return null
  }

  if (allWidget?.length > 0 && show && !type) { // Only for home page
    if (stringIndex) {
      if ((index + 1) > allWidget?.length) {
        return null
      } else {
        const Widget = Components[allWidget[index]?.eType]
        return Widget ? (
          <>
            <Widget />
          </>
        ) : null
      }
    } else {
      return (
        allWidget?.filter((e) => e.sPosition === position && e.eType !== notShowFanTips).map((e, i) => {
          const Widget = Components[e.eType]
          if (Widget) {
            return (
              <React.Fragment key={e.eType}>
                {i >= 1 ? (
                  <>
                  <Widget />
                    {
                      (((i === 2 || i === 4) && position === 'l') || ((i === 1 || i === 2) && position === 'r')) && <ATSAds />
                    }
                    {
                      (i === 1) && position === 'r' && (
                        <div className='d-flex justify-content-center mb-2'>
                          <ReviveAds {...add300} className='mb-2' />
                        </div>
                      )
                    }
                    {/* <Widget key={e.eType} /> */}
                  </>
                ) : (
                  // <Widget key={e.eType} />
                  <Widget />
                )}
                {/* {(i === 1 && position === 'r') && (
                  <Ads
                    id="div-ad-gpt-138639789-16600-Desktop_HP_RightBTF_3--55716-2"
                    adIdDesktop="oneturf2022_Desktop_HP_RightBTF_300x250"
                    dimensionDesktop={[300, 250]}
                    className="mb-3"
                  />
                )} */}
              </React.Fragment>
            )
          } else {
            return null
          }
        })
      )
    }
  } else if (type) { // For others pages
    const Widget = Components[type]
    return Widget ? <Widget /> : null
  } else {
    return null
  }
}

AllWidget.propTypes = {
  position: PropTypes.string,
  index: PropTypes.number,
  show: PropTypes.bool,
  type: PropTypes.string,
  notShowFanTips: PropTypes.string
}
export default AllWidget
